import { QuotaUsageDetails, Subscription } from "fond/types";

type DesignQuota = QuotaUsageDetails & {
  hasDesign: boolean;
};

type PlannerQuota = QuotaUsageDetails & {
  hasPlanner: boolean;
};

/**
 * Get the combined design quota and usage for the active billing cycle of the subscription.
 */
export const getDesignQuota = (subscription: Subscription | null | undefined): DesignQuota => {
  const design = subscription?.Design;
  const Quota = design?.Quota ?? 0;
  const QuotaUsage = design?.QuotaUsage ?? 0;
  const DataPackQuota = subscription?.DesignDataPackQuota ?? 0;
  const DataPackUsage = subscription?.DesignDataPackUsage ?? 0;
  return {
    Quota,
    QuotaUsage,
    DataPackQuota,
    DataPackUsage,
    AvailableQuota: Quota + DataPackQuota - QuotaUsage - DataPackUsage,
    hasDesign: Quota + DataPackQuota > 0,
  };
};

/**
 * Get the combined planner quota and usage for the active billing cycle of the subscription.
 */
export const getPlannerQuota = (subscription: Subscription | null | undefined): PlannerQuota => {
  const planner = subscription?.Planner;
  const Quota = planner?.Quota ?? 0;
  const QuotaUsage = planner?.QuotaUsage ?? 0;
  const DataPackQuota = subscription?.DataPackQuota ?? 0;
  const DataPackUsage = subscription?.DataPackUsage ?? 0;
  return {
    Quota,
    QuotaUsage,
    DataPackQuota,
    DataPackUsage,
    AvailableQuota: Quota + DataPackQuota - QuotaUsage - DataPackUsage,
    hasPlanner: !!planner,
  };
};
